import { format } from "date-fns";
import { ro } from "date-fns/locale";
import { useTranslation } from "@/hooks/useTranslation";
import type { AdminPurchaseAuditEntry } from "@/services/api/management";

interface PurchaseAuditTrailProps {
  entries: AdminPurchaseAuditEntry[];
}

/**
 * JUB-157 (F12a): administrator actions on one purchase, oldest first, each
 * with its actor, time and the full reason (never cut).
 */
export function PurchaseAuditTrail({ entries }: PurchaseAuditTrailProps) {
  const { t, currentLanguage } = useTranslation();
  const dateLocale = currentLanguage === "ro" ? ro : undefined;

  return (
    <ol className="space-y-1" data-testid="admin-purchase-audit-trail">
      {entries.map((entry, index) => (
        <li key={`${entry.at}-${index}`} className="break-words" data-testid="admin-purchase-audit-entry">
          <span className="font-medium text-foreground">
            {t(`management.purchases.auditActions.${entry.action}`) || entry.action}
          </span>
          {" · "}
          {t("management.purchases.auditBy", { id: String(entry.actorUserId ?? "—") })}
          {entry.at && <> · {format(new Date(entry.at), "PPp", { locale: dateLocale })}</>}
          {entry.relatedPurchaseId !== null && entry.relatedPurchaseId !== undefined && (
            <> · {t("management.purchases.auditRelated", { id: String(entry.relatedPurchaseId) })}</>
          )}
          {entry.reason && <span className="block whitespace-pre-wrap">{entry.reason}</span>}
        </li>
      ))}
    </ol>
  );
}
